import { FUSIONNOW_BASE_URL } from './fusionNowAuth';

const MARKETPLACE_SECRET =
  process.env.REACT_APP_FUSIONNOW_APP_SECRET_KEY ?? '';

// ── Types ─────────────────────────────────────────────────────────────────────

export interface AppTrigger {
  id: number;
  trigger_name: string;
  event_types: string[];
  key: string;
  recommended: boolean;
}

export interface AppAction {
  id: number;
  name: string;
  form_fields: Record<string, unknown>;
  request_method: string;
  key: string;
  recommended: boolean;
}

export interface App {
  id: number;
  name: string;
  description?: string;
  icon: { url: string };
  key: string;
  active: boolean;
  user_id: number;
  account_id: number;
  created_at: string;
  updated_at: string;
  recommended: boolean;
  is_pre_registered: boolean;
  ai_builder: boolean;
  app_triggers: AppTrigger[];
  app_actions: AppAction[];
}

export interface AppsMeta {
  current_page: number;
  next_page: number | null;
  prev_page: number | null;
  total_pages: number;
  total_count: number;
}

export interface AppsResponse {
  apps: App[];
  meta: AppsMeta;
}

// ── API calls ─────────────────────────────────────────────────────────────────

export async function getApps(page = 1, search = '', perPage = 12): Promise<AppsResponse> {
  const searchParam = search.trim()
    ? `&keyword=${encodeURIComponent(search.trim())}`
    : '';
  const url = `${FUSIONNOW_BASE_URL}/api/marketplace/apps?per_page=${perPage}&page=${page}${searchParam}`;

  const res = await fetch(url, {
    headers: { 'X-Marketplace-Secret': MARKETPLACE_SECRET }
  });
  if (!res.ok) throw new Error(`Failed to load apps: ${res.status}`);

  const data = await res.json();
  if (!data.success) throw new Error('Apps API returned success: false');

  return {
    apps: data.data as App[],
    meta: data.meta_attributes as AppsMeta
  };
}
